export default __webpack_public_path__ + "static/media/meiteli-wenn-due-witt-go-tanzae.165e666b.pdf";